var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("template-editor", {
    ref: "editor",
    attrs: {
      params: _vm.list,
      "tool-fixed": true,
      id: _vm.id
    },
    on: {
      paramsChange: _vm.paramsChange
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };